export default {
  namespaced: true,
  state() {
    return {
      //del
      show: false,
      confirm: false,
      confirm2: false,
      confirm3: false,
      number: 1,
      items: '',
      //unset
      confirmUnset: false,
      showUnset: false
    }
  },
  mutations: {
    SET_NUMBER(state,data) {
      state.number = data
    },
    SET_SHOW(state,data) {
      state.show = data
    },
    SET_CONFIRM(state,data) {
      state.confirm = data
    },
    SET_ITEMS(state,data) {
      state.items = data
    },
    SET_CONFIRM2(state, data) {
      state.confirm2 = data
    },
    SET_CONFIRM3(state,data) {
      state.confirm3 = data
    },

    SET_SHOW_UNSET(state,data) {
      state.showUnset = data
    },
    SET_CONFIRM_UNSET(state, data) {
      state.confirmUnset = data
    }
  }
}
